import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isPending2FA } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login but save the attempted location
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (isPending2FA) {
    return <Navigate to="/twoFactorLogin" replace />;
  }

  return children;
};

export default ProtectedRoute;